import React, { useState, useEffect, useRef } from 'react';
import LandingPage from './new/Landing';


// Home Page
const Home = () => {
  // eslint-disable-next-line
  const [isSticky, setIsSticky] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const heroPosition = heroRef.current.getBoundingClientRect();
        const heroTop = heroPosition.top;

        if (heroTop <= 0) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <LandingPage />
    </div>
  );
};

export default Home;
